module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"system":"System","messageOne":"Message {name}","messageMultiple":"Message {commaSeparatedNames} and {lastParticipantName}"},"es":{"system":"Sistema","messageOne":"Message {name}","messageMultiple":"Message {commaSeparatedNames} and {lastParticipantName}"}}')
  delete Component.options._Ctor
}
